











import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { ItemStarActions } from '@/actions/item-star-actions';

import { UserModule, UserStore} from '@/store/modules/user';

import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';
import { UserProfile } from '@/models/user-profile';
import { UserFollowActions } from '../actions/user-follow-actions';

@Component({})
export default class UserFollowWidget extends Vue {
  @Prop(UserProfile) public user!: UserProfile;
  isFollowed: boolean = false;

  checkIsFollowed() {
    this.isFollowed = UserModule.followedUserIds.indexOf(this.user.id) > -1;
  }

  created() {
    this.checkIsFollowed();

    this.$store.subscribe((mutation, state: any) => {
      if (mutation.type === UserStore.SET_FOLLOWED_USER_IDS_MUTATION) {
        this.checkIsFollowed();
      }
    });
  }

  toggleUserFollow() {
    if (!this.isLoggedIn) {
      this.$router.push('/login');
      return;
    }

    const wasFollowed = this.isFollowed;
    this.isFollowed = !this.isFollowed;

    if (wasFollowed) {
      UserFollowActions.unfollowUser({
        srcUserId: UserModule.currentUserId,
        destUserId: this.user.id
      });
      this.user.numFollowers -= 1;
    } else {
      UserFollowActions.followUser({
        srcUserId: UserModule.currentUserId,
        destUserId: this.user.id
      });
      this.user.numFollowers += 1;
    }
  }

  get isLoggedIn() {
    return UserModule.isLoggedIn;
  }
}
